import { createApp } from 'vue';
import App from './App.vue';
import { createVuestic } from 'vuestic-ui';
import 'vuestic-ui/css';
import router from './router/index';
import axios from 'axios';
import Toaster from "@meforma/vue-toaster";

const app = createApp(App)
app.use(createVuestic())
app.use(router);
app.use(Toaster, { position: "bottom", duration: 4000 });
app.config.globalProperties.axios = axios;
app.config.globalProperties.wsocket = "";

app.mount('#app')

axios.interceptors.request.use(
    request => {
        const url = window.location.href.split('/')[2].split(':');
        const tokenName = url[0] + '_' + url[1] + '_authToken'
        if (localStorage.getItem(tokenName)) {
            request.headers['x-access-token'] = localStorage.getItem(tokenName);
            request.headers['Cache-Control'] = "no-cache";
            request.headers['Pragma'] = "no-cache";
            request.headers['Expires'] = "0";
        }
        return request;
    }
)

axios.interceptors.response.use(
    response => response,
    error => {
        const { response } = error;
        const errData = response?.data;

        if (errData.code == 'EXPIRED') {
            localStorage.clear();
            app.$toast.error("Session Expired");
            if (this.$wsocket) this.$wsocket.close();
            router.push({ name: 'Login' });
            return;
        } else if (errData.code == 'PERMISSION_DENIED') {
            localStorage.clear();
            app.$toast.error("No Permission Access to this page");
            if (this.$wsocket) this.$wsocket.close();
            router.push({ name: 'Login' });
            return;
        }
        return Promise.reject(error);
    }
)
